"use client";

/**
 * LoggedInShellBodyAttr — sets `body[data-logged-in-page]` while the
 * `LoggedInShell` is mounted.
 *
 * Mirrors `OwnerCanvas`' `data-canvas-page` body attribute pattern. The
 * attribute lets `globals.css` (and any other body-scoped CSS rule) target
 * the cross-project shell separately from the canvas — currently used to
 * disable document overscroll bounce on macOS so the app doesn't rubber-band
 * the whole page like a webpage. Page-level `<main>` still owns its own
 * scroll, so this attribute only kills the document-level bounce on top of it.
 *
 * Kept as a separate client component so `LoggedInShell` can remain a server
 * component (it has no other client semantics besides this body attribute).
 */
import { useEffect } from "react";

const BODY_LOGGED_IN_SHELL_ATTR = "data-logged-in-page";

export function LoggedInShellBodyAttr() {
  useEffect(() => {
    document.body.setAttribute(BODY_LOGGED_IN_SHELL_ATTR, "true");
    return () => document.body.removeAttribute(BODY_LOGGED_IN_SHELL_ATTR);
  }, []);

  return null;
}
